import { toast } from "react-toastify";
import * as actionTypes from "./actionTypes";
import pagoService from "../../api/pagoService";

const setLoadingProcesarPago = (loading) => {
  return { type: actionTypes.LOADING_PROCESAR_PAGO, payload: { loading } };
};

const setLoadingCalcularItf = (loading) => {
  return { type: actionTypes.LOADING_CALCULAR_ITF, payload: { loading } };
};

const setLoadingDisponibilidadPago = (loading) => {
  return {
    type: actionTypes.LOADING_DISPONIBILIDAD_PAGO,
    payload: { loading },
  };
};

const setLoadingValidarProgramaEstado = (loading) => {
  return {
    type: actionTypes.LOADING_VALIDAR_PROGRAMA_ESTADO,
    payload: { loading },
  };
};

const setValidacionProgramaEstado = (validacionProgramaEstado) => {
  return {
    type: actionTypes.VALIDACION_PROGRAMA_ESTADO,
    payload: { validacionProgramaEstado },
  };
};

const setDisponibilidadPago = (disponibilidadPago) => {
  return {
    type: actionTypes.DISPONIBILIDAD_PAGO,
    payload: { disponibilidadPago },
  };
};

const setMsgErrorServicioNoDisponible = (msgErrorServicioNoDisponible) => {
  return {
    type: actionTypes.MSG_ERROR_SERVICIO_NO_DISPONIBLE,
    payload: { msgErrorServicioNoDisponible },
  };
};

export const procesarPagoCulqi = (request) => async (dispatch) => {
  dispatch(setLoadingProcesarPago(true));
  try {
    const response = await pagoService.cargoAmortizarCulqi(request);
    dispatch(setLoadingProcesarPago(false));
    return response;
  } catch (error) {
    dispatch(setLoadingProcesarPago(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const verificarDisponibilidadPago = () => async (dispatch) => {
  dispatch(setLoadingDisponibilidadPago(true));
  try {
    const response = await pagoService.verificarDisponibilidadPago();
    dispatch(setDisponibilidadPago(response.data.disponible));
    dispatch(setLoadingDisponibilidadPago(false));
    return response;
  } catch (error) {
    dispatch(setDisponibilidadPago(false));
    if (error && error.data && error.data.status !== 401) {
      dispatch(setMsgErrorServicioNoDisponible(error.data.message));
      toast.error(error.data.message);
    }
    dispatch(setLoadingDisponibilidadPago(false));
  }
};

export const calcularItf = (request) => async (dispatch) => {
  dispatch(setLoadingCalcularItf(true));
  try {
    const response = await pagoService.calcularItf(request);
    dispatch(setLoadingCalcularItf(false));
    return response.data.itf;
  } catch (error) {
    dispatch(setLoadingCalcularItf(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const procesarPagoCargoEnCuenta = (request) => async (dispatch) => {
  dispatch(setLoadingProcesarPago(true));
  try {
    const response = await pagoService.cargoAmortizarEnCuenta(request);
    dispatch(setLoadingProcesarPago(false));
    return response;
  } catch (error) {
    dispatch(setLoadingProcesarPago(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const validarProgramaEstado = () => async (dispatch) => {
  dispatch(setLoadingValidarProgramaEstado(true));
  try {
    const response = await pagoService.validarProgramaEstado();
    dispatch(setValidacionProgramaEstado(response.data));
    dispatch(setLoadingValidarProgramaEstado(false));
    return response;
  } catch (error) {
    dispatch(setLoadingValidarProgramaEstado(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};
